var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack349({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3,
    y: 2.96,
    width: 10,
    height: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M4.41,10.74V5.37H5V8L7.17,5.37H8L6.12,7.55,8,10.74H7.28L5.71,8,5,8.88v1.86Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.53,10.74V5.37h1.65a2.66,2.66,0,0,1,.87.11,1.2,1.2,0,0,1,.61.51,1.78,1.78,0,0,1,.22.93,1.79,1.79,0,0,1-.37,1.18,1.52,1.52,0,0,1-1.27.46H9.11v2.18Zm.58-2.81h1.14A1.07,1.07,0,0,0,11,7.68,1,1,0,0,0,11.28,7a1.18,1.18,0,0,0-.12-.55.69.69,0,0,0-.3-.31A1.69,1.69,0,0,0,10.24,6H9.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack349);
export default __webpack_public_path__ + "static/media/Symbol_pack_349.3eeba4163ae32b0c12837be884528d0d.svg";
export { ForwardRef as ReactComponent };